import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Animated, View } from 'react-native';
import { useAnimation } from '../Animations/AnimationHooks';
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { component } from '../../Decorators/Component';
import { CoreConfig } from './../../../CoreConfig';
export const ProgressBarView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.progressBar,
    style(theme) {
        var _a, _b;
        return {
            container: {
                position: 'relative',
                height: 6,
                width: '100%'
            },
            bar: {
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                borderRadius: 4,
                backgroundColor: ((_a = theme.colors) === null || _a === void 0 ? void 0 : _a.link_color) || '#DBE2EB'
            },
            progress: {
                position: 'absolute',
                top: 0,
                left: 0,
                bottom: 0,
                borderRadius: 4,
                backgroundColor: ((_b = theme.colors) === null || _b === void 0 ? void 0 : _b.secondary_color) || 'rgba(17, 85, 204, 1)'
            }
        };
    }
})(({ containerStyle, style, startValue, endValue, value, size, barColor, progressColor }) => {
    const [width, setWidth] = useAnimation({ initialValue: value || 0, nativeDriver: false });
    useEffect(() => {
        setWidth(value);
    }, [value]);
    const interpolatedWidth = width.interpolate({
        inputRange: [startValue || 0, endValue || 100],
        outputRange: ['0%', '100%']
    });
    return (_jsxs(View, { style: [style === null || style === void 0 ? void 0 : style.container, !!size && { height: size }, containerStyle], children: [_jsx(View, { style: [style === null || style === void 0 ? void 0 : style.bar, !!barColor && { backgroundColor: barColor }] }), _jsx(Animated.View, { style: [style === null || style === void 0 ? void 0 : style.progress, { width: interpolatedWidth }, !!progressColor && { backgroundColor: progressColor }] })] }));
});
